export default __webpack_public_path__ + "static/media/alphafitness.8aae9bca.PNG";